export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const COMING_SOON = '/coming-soon';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const SELECT_INTERESTS = '/interest';
export const FEATURE = '/feature/';
export const NOT_FOUND = '*';


// WEBPACK FOOTER //
// ./src/constants/routes.js